module.exports = __webpack_public_path__ + "img/reorder.e863b44.png";